module.exports = __webpack_public_path__ + "img/line-chart-dark.0ce9ba96.svg";